// import Robots from '@System/views/robots'
// import NotifyConfigs from '@System/views/notifyconfig'
// import NotifyConfigCreate from '@System/views/notifyconfig/create'
// import MailConfig from '@System/views/mail-config'
// import Notification from '@System/views/notification'
// import Contact from '@System/views/contact'
// import NotifyTopic from '@System/views/notify-topic'

import Layout from '@/layouts/RouterView'
import { hasServices, hasSetupKey, isLicense2 } from '@/utils/auth'
import store from '@/store'
import i18n from '@/locales'
import { isScopedPolicyMenuHidden } from '@/utils/scopedPolicy'

const ThirdParty = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/third-party')
const DictionarySetting = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/dictionary-setting')
const GlobalSetting = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/global-setting')
const Endpoint = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/endpoint')
const Notice = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/notice')
const CompanyInfo = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/companyinfo')
const WorkflowConfig = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/workflow-config')
const Strategyallocation = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/strategyallocation')
const Strategydefinition = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/strategydefinition')
const StrategydefinitionCreate = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/strategydefinition/create')
const Tag = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@Cloudenv/views/tag')
const Inspection = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/inspection')
const BastionHost = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/bastion-host')
const Service = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/service')

export default {
  index: 99,
  meta: {
    label: () => process.env.VUE_APP_PLATFORM === 'operation' ? i18n.t('system.text_1') : i18n.t('system.text_2'),
    icon: 'menu-setting',
  },
  menus: [
    {
      meta: {
        label: i18n.t('inspection.menu.group.inspect'),
      },
      submenus: [
        {
          path: '/inspection',
          component: Layout,
          meta: {
            label: i18n.t('inspection.menu.env_inspection'),
            permission: 'check_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.inspection')) {
                return true
              }
              return !hasServices('autoupdate') || !store.getters.isAdminMode || store.getters.isSysCE
            },
          },
          children: [
            {
              name: 'Inspection',
              path: '',
              component: Inspection,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('system.text_12'),
      },
      submenus: [
        {
          path: '/processmanage',
          meta: {
            label: i18n.t('system.text_13'),
            permission: 'process_manage_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.processmanage')) {
                return true
              }
              return !hasServices('itsm') || store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'WorkflowConfig',
              path: '',
              component: WorkflowConfig,
            },
          ],
        },
        {
          path: '/thirdparty',
          meta: {
            label: i18n.t('system.text_14'),
            permission: 'extra_users_create',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.thirdparty')) {
                return true
              }
              return !hasServices('itsm') || !store.getters.isAdminMode || store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'ThirdParty',
              path: '',
              component: ThirdParty,
            },
          ],
        },
      ],
    },
    // {
    //   meta: {
    //     label: i18n.t('system.text_564'),
    //   },
    //   submenus: [
    //     {
    //       path: '/notification',
    //       meta: {
    //         label: i18n.t('system.text_16'),
    //         permission: 'notifications_list',
    //         hidden: () => {
    //           if (isScopedPolicyMenuHidden('sub_hidden_menus.notification')) {
    //             return true
    //           }
    //           return !hasServices('notify')
    //         },
    //         t: 'dictionary.webconsole',
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'Notification',
    //           path: '',
    //           component: Notification,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/notify-topic',
    //       meta: {
    //         label: i18n.t('system.text_16'),
    //         permission: 'topics_list',
    //         hidden: () => {
    //           if (isScopedPolicyMenuHidden('sub_hidden_menus.notify-topic')) {
    //             return true
    //           }
    //           if (!(store.getters.isAdminMode || store.getters.isDomainMode)) {
    //             return true
    //           }
    //           return !hasServices('notify')
    //         },
    //         t: 'dictionary.notify-topic',
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'NotifyTopic',
    //           path: '',
    //           component: NotifyTopic,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/mailconfig',
    //       meta: {
    //         label: i18n.t('system.text_19'),
    //         permission: 'configs_list',
    //         hidden: () => {
    //           return true
    //         },
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'MailConfig',
    //           path: '',
    //           component: MailConfig,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/notifyconfig',
    //       meta: {
    //         label: i18n.t('system.text_19'),
    //         hidden: () => {
    //           if (isScopedPolicyMenuHidden('sub_hidden_menus.mailconfig')) {
    //             return true
    //           }
    //           return !hasServices('notify')
    //         },
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'NotifyConfig',
    //           path: '',
    //           component: NotifyConfigs,
    //         },
    //         {
    //           name: 'NotifyConfigCreate',
    //           path: 'create',
    //           component: NotifyConfigCreate,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/contact',
    //       meta: {
    //         label: i18n.t('common_27'),
    //         permission: 'contacts_list',
    //         hidden: () => {
    //           if (isScopedPolicyMenuHidden('sub_hidden_menus.contact')) {
    //             return true
    //           }
    //           return !store.getters.isAdminMode && !store.getters.isDomainMode
    //         },
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'Contact',
    //           path: '',
    //           component: Contact,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/robot',
    //       meta: {
    //         label: i18n.t('system.robot_manage'),
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'Robots',
    //           path: '',
    //           component: Robots,
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      meta: {
        label: i18n.t('system.text_15'),
      },
      submenus: [
        {
          path: '/notice',
          meta: {
            label: i18n.t('system.text_20'),
            permission: 'notices_list',
            t: 'dictionary.notice',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.notice')) {
                return true
              }
              return store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'Notice',
              path: '',
              component: Notice,
            },
          ],
        },
        {
          path: '/companyinfo',
          meta: {
            label: i18n.t('system.text_18'),
            permission: 'infos_list',
            t: 'dictionary.companyinfo',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.companyinfo')) {
                return true
              }
              return false
            },
          },
          component: Layout,
          children: [
            {
              name: 'CompanyInfo',
              path: '',
              component: CompanyInfo,
            },
          ],
        },
        {
          path: '/endpoint',
          meta: {
            label: i18n.t('system.text_21'),
            permission: 'endpoints_list',
            t: 'dictionary.endpoint',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.endpoint')) {
                return true
              }
              return store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'Endpoint',
              path: '',
              component: Endpoint,
            },
          ],
        },
        {
          path: '/bastion-host',
          meta: {
            label: i18n.t('bastionHost.title'),
            permission: 'bastion_hosts_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.bastion_host') || (isLicense2() && !hasSetupKey('bastionhost'))) {
                return true
              }
              return !hasServices('bastionhost') || !store.getters.isAdminMode || store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'BastionHost',
              path: '',
              component: BastionHost,
            },
          ],
        },
        {
          path: '/service',
          meta: {
            label: i18n.t('system.system_service'),
            permission: 'services_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.service')) {
                return true
              }
              return !store.getters.isAdminMode
            },
          },
          component: Layout,
          children: [
            {
              name: 'Service',
              path: '',
              component: Service,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('cloudenv.text_16'),
      },
      submenus: [
        {
          path: '/tag',
          meta: {
            label: i18n.t('cloudenv.text_16'),
            permission: 'metadatas_perform_tag_value_pairs',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.tag')) {
                return true
              }
              if (!(hasServices('image') || hasServices('identity') || hasServices('compute'))) {
                return true
              }
              return store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'Tag',
              path: '',
              component: Tag,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('cloudenv.text_499'),
      },
      submenus: [
        {
          path: '/strategyallocation',
          meta: {
            label: i18n.t('cloudenv.text_500'),
            permission: 'scopedpolicybindings_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.strategyallocation')) {
                return true
              }
              return store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'Strategyallocation',
              path: '',
              component: Strategyallocation,
            },
          ],
        },
        {
          path: '/strategydefinition',
          meta: {
            label: i18n.t('cloudenv.text_501'),
            permission: 'scopedpolicies_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.strategydefinition')) {
                return true
              }
              return store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'Strategydefinition',
              path: '',
              component: Strategydefinition,
            },
            {
              name: 'StrategydefinitionCreate',
              path: 'create',
              component: StrategydefinitionCreate,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('system.text_22'),
        hidden: () => !store.getters.isAdminMode,
      },
      submenus: [
        {
          path: '/dictionarysetting',
          meta: {
            label: i18n.t('system.text_23'),
            permission: 'dictionary_get',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.dictionarysetting')) {
                return true
              }
              // return !store.getters.isAdminMode || store.getters.setting.language !== 'zh-CN'
              return !store.getters.isAdminMode || store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'DictionarySetting',
              path: '',
              component: DictionarySetting,
            },
          ],
        },
        {
          path: '/globalsetting',
          meta: {
            label: i18n.t('system.text_22'),
            permission: 'services_get',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.globalsetting')) {
                return true
              }
              return !store.getters.isAdminMode || store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'GlobalSettings',
              path: '',
              component: GlobalSetting,
            },
          ],
        },
      ],
    },
  ],
}
